<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  date?: string | Date | null
  displayFullDate?: boolean
  showOnlyClock?: boolean
  hideIcon?: boolean
  isSensitive?: boolean
  oneLine?: boolean
  simple?: boolean
  showSeconds?: boolean
}>()

const formattedDate = computed(() => {
  const date = typeof props.date == 'string' ? new Date(props.date) : props.date

  if (props.showOnlyClock) {
    return date.toLocaleTimeString('no-NO', {
      hour: 'numeric',
      minute: 'numeric',
    })
  }

  return date.toLocaleDateString('en-NO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
})
const formattedWholeDate = computed(() => {
  const dateObj = typeof props.date == 'string' ? new Date(props.date) : props.date
  // using the the format February 1, 2024 at 13:17

  const date = dateObj.toLocaleDateString('en-NO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  const time = dateObj.toLocaleTimeString('no-NO', {
    hour: 'numeric',
    minute: 'numeric',
  })

  return date + ' at ' + time
})
const simpleDate = computed(() => {
  const dateObj = typeof props.date == 'string' ? new Date(props.date) : props.date

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }
  if (props.showSeconds) {
    options.hour = '2-digit'
    options.minute = '2-digit'
    options.second = '2-digit'
    options.hour12 = false
  }

  const formatter = new Intl.DateTimeFormat('no-NO', options) // Use 'no-NO' for dd/mm/yyyy order

  const formattedDate = formatter.format(dateObj).replace(/\//g, '.') // Replace slashes with dots
  return formattedDate
})

const sensitiveClass = computed(() => {
  return props.isSensitive ? 'sentry-mask' : ''
})
</script>
<template>
  <span v-if="props.date">
    <template v-if="props.simple"> {{ simpleDate }}</template>
    <template v-else>
      {{ props.displayFullDate ? formattedWholeDate : formattedDate }}
      <!-- <CalendarIcon v-if="!props.hideIcon" :size="16" class="shrink-0" /> -->
    </template>
  </span>
  <span v-else>-</span>
  <!-- <TooltipProvider v-if="props.date">
    <Tooltip>
      <TooltipTrigger as-child>
        <div
          :class="
            cn('flex items-center gap-2 justify-start', sensitiveClass, {
              'text-ellipsis whitespace-nowrap': props.oneLine,
            })
          "
        >
          {{ props.displayFullDate ? formattedWholeDate : formattedDate }}
          <Calendar v-if="!props.hideIcon" :size="16" class="shrink-0" />
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p :class="sensitiveClass">{{ formattedWholeDate }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
  <span v-else>-</span> -->
</template>
